const Hero = ({ title, number }) => {
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="hero-text">
          <h1>RO Water Purifier Service & Repair{title}</h1>
          <p>Same Day Service | Expert Technicians | Genuine Spare Parts</p>

          <div className="hero-buttons">
            <a href="tel:9031062015" className="btn-green">📞 Call Now</a>
            <a href="#contact" className="btn-blue">📋 Book Service</a>
          </div>

          <div className="hero-badges">
            <span>⭐ 4.8 Rated on Google</span>
            <span>5000+ Happy Customers</span>
            <span>10+ Years Experience</span>
          </div>
        </div>

        <div className="hero-image">
          <img src="/img/repairimg.png" alt="RO Purifier" />
        </div>
      </div>
    </section>
  );
};

export default Hero;